var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1385 23.2825C11.6131 23.2825 9.56594 25.3297 9.56594 27.855C9.56594 28.6968 10.2483 29.3792 11.0901 29.3792H26.3319C27.1737 29.3792 27.8561 28.6968 27.8561 27.855C27.8561 25.3297 25.8089 23.2825 23.2836 23.2825H14.1385ZM6.51758 27.855C6.51758 23.6461 9.92957 20.2341 14.1385 20.2341H23.2836C27.4925 20.2341 30.9045 23.6461 30.9045 27.855C30.9045 30.3804 28.8573 32.4276 26.3319 32.4276H11.0901C8.56477 32.4276 6.51758 30.3804 6.51758 27.855Z",
    fill: "#ffbb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7107 8.04055C16.1854 8.04055 14.1382 10.0877 14.1382 12.6131C14.1382 15.1384 16.1854 17.1856 18.7107 17.1856C21.2361 17.1856 23.2833 15.1384 23.2833 12.6131C23.2833 10.0877 21.2361 8.04055 18.7107 8.04055ZM11.0898 12.6131C11.0898 8.40418 14.5018 4.99219 18.7107 4.99219C22.9197 4.99219 26.3316 8.40418 26.3316 12.6131C26.3316 16.822 22.9197 20.234 18.7107 20.234C14.5018 20.234 11.0898 16.822 11.0898 12.6131Z",
    fill: "#ffbb00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.08d9617b4b736b7bc70bf6b54615dfb1.svg";
export { ForwardRef as ReactComponent };